import http from "../http-common";

const getVitalSignsDay = (date) => {
  return http.get("/medical-forms/vital-signs", {
    params: date ? { date } : undefined,
  });
};

const saveVitalSignsDay = (payload) => {
  return http.put("/medical-forms/vital-signs", payload);
};

const getRoundingDay = () => {
  return http.get("/medical-forms/rounding");
};

const saveRoundingDay = (payload) => {
  return http.put("/medical-forms/rounding", payload);
};

export const MedicalFormService = {
  getVitalSignsDay,
  saveVitalSignsDay,
  getRoundingDay,
  saveRoundingDay,
};
